package com.gsb.vyapar.bhagya.presentation.business.uistate

/**
 * Represents the persisted camera state for the business map.
 * The latitude/longitude deltas describe the visible region span in degrees.
 */
data class BusinessMapCameraPosition(
    val latitude: Double,
    val longitude: Double,
    val latitudeDelta: Double,
    val longitudeDelta: Double,
)

/**
 * Stores map specific UI state that should survive navigation events.
 */
data class BusinessMapViewState(
    val cameraPosition: BusinessMapCameraPosition? = null,
    val selectedBusinessId: String? = null,
)
